import {
  Button,
  Flex,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import useAxios from "axios-hooks";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import WhitelistIpRow from "components/WhitelistIp/WhitelistIpRow";
import WhitelistIpAddDialog from "components/WhitelistIp/WhitelistIpAddDialog";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { checkLogin, getToken } from "../../../utils/authentication";
import { TablePagination } from "@trendmicro/react-paginations";
import { initialFilter } from "utils/constant";
import { API_ROUTES } from "utils/constant";

function WhitelistIp() {
  const history = useHistory();
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const [filter, setFilter] = useState(initialFilter);
  const xToken = getToken();
  const isLoggedIn = checkLogin();

  const { isOpen: isAddOpen, onOpen: onAddOpen, onClose: onAddClose } =
    useDisclosure();

  const [{ data, loading }, refetch] = useAxios({
    url: API_ROUTES.IpList,
    headers: { xToken },
    params: filter,
  });

  useEffect(() => {
    if (!isLoggedIn) history.push("/auth/signin");
  }, [isLoggedIn, history]);

  const ips = data?.data || [];

  return (
    <>
      <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
        <Card bg="#fff" overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
          <CardHeader p="6px 0px 22px 0px">
            <Text fontSize="xl" color={textColor} fontWeight="bold">
              Whitelist IP
            </Text>
            <Button variant="primary" maxH="30px" m="10px" onClick={onAddOpen}>
              Thêm IP
            </Button>
          </CardHeader>
          <CardBody>
            <Table variant="simple" color={textColor}>
              <Thead>
                <Tr my=".8rem" pl="0px" color="gray.400">
                  <Th pl="0px" borderColor={borderColor} color="gray.400">
                    IP
                  </Th>
                  <Th borderColor={borderColor} color="gray.400">
                    Ghi chú
                  </Th>
                  <Th borderColor={borderColor} color="gray.400">
                    Tạo lúc
                  </Th>
                  <Th borderColor={borderColor} color="gray.400"></Th>
                </Tr>
              </Thead>
              <Tbody>
                {ips.map((row, index, arr) => (
                  <WhitelistIpRow
                    key={row._id}
                    detail={row}
                    isLast={index === arr.length - 1}
                    refetch={refetch}
                  />
                ))}
              </Tbody>
            </Table>
            <Flex justifyContent="flex-end">
              <TablePagination
                type="full"
                page={data?.pagination?.page}
                pageLength={data?.pagination?.pageSize}
                totalRecords={data?.pagination?.count}
                onPageChange={({ page, pageLength }) =>
                  setFilter({
                    ...filter,
                    pageSize: pageLength,
                    pageIndex: page - 1,
                  })
                }
                prevPageRenderer={() => <i className="fa fa-angle-left" />}
                nextPageRenderer={() => <i className="fa fa-angle-right" />}
              />
            </Flex>
          </CardBody>
        </Card>
      </Flex>
      {isAddOpen && (
        <WhitelistIpAddDialog
          isOpen={isAddOpen}
          onClose={onAddClose}
          refetch={refetch}
        />
      )}
    </>
  );
}

export default WhitelistIp;
